export default {"src":"/_next/static/media/painting.b154008d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};